import { IUploadImage } from '@Domains/UploadImage';
import { ERROR_MESSAGE_UPLOAD_ASSETS } from './validators';
import { checkMessageEn, validateSpace } from '@Utils/validation';
export type AssetType = {
  id?: number | null;
  descriptionTh?: string | null;
  descriptionEn?: string | null;
  fileNameTh?: string | null;
  fileNameEn?: string | null;
  isUseSameFile: boolean;
  sequence?: number;
  urlEn?: string | null;
  urlTh?: string | null;
  markedForDeletion?: boolean;
  fileNameThForDeletion?: string;
  fileNameEnForDeletion?: string;
};

export const mapdata = (data: IUploadImage): AssetType => {
  return {
    id: data.id,
    descriptionEn: data.descriptionEn,
    descriptionTh: data.descriptionTh,
    fileNameTh: data.fileNameTh,
    fileNameEn: data.fileNameEn,
    isUseSameFile: data.isUseSameFile,
    sequence: data.sequence,
    urlEn: data.urlEn,
    urlTh: data.urlTh,
  };
};

export const checkAssetsValidTh = <
  T extends {
    assets?: { fileNameTh?: string | null; descriptionTh?: string }[];
  }
>(
  section?: T
): boolean => {
  if (!section?.assets || section.assets.length === 0) {
    return true;
  }

  return section.assets.every((asset) => {
    const isFileNameThValid =
      asset.fileNameTh && asset.fileNameTh.trim() !== '';
    const isDescriptionThValid =
      !asset.descriptionTh || validateSpace(asset.descriptionTh);

    return isFileNameThValid && isDescriptionThValid;
  });
};

export const checkAssetsValidEn = <
  T extends {
    assets?: { fileNameEn?: string | null; descriptionEn?: string }[];
  }
>(
  section?: T
): boolean => {
  if (!section?.assets || section.assets.length === 0) {
    return true;
  }

  return section.assets.every((asset) => {
    const isFileNameEnValid =
      asset.fileNameEn && asset.fileNameEn.trim() !== '';
    const isDescriptionEnValid =
      !asset.descriptionEn ||
      (checkMessageEn(asset.descriptionEn) &&
        validateSpace(asset.descriptionEn));

    return isFileNameEnValid && isDescriptionEnValid;
  });
};

export const getLocaleErrorMessage = (asset: any, locale: string) => {
  if (locale === 'th') {
    return asset?.fileNameTh?.message;
  } else if (locale === 'en') {
    return asset?.fileNameEn?.message;
  }
  return undefined;
};

export const getErrorMessage = (
  errors: any,
  name: string,
  index: number,
  locale: string
) => {
  const errorPath = name.split('.');
  let errorMessage;

  if (errorPath.length === 1) {
    const asset = errors[name]?.assets?.[index];
    errorMessage = getLocaleErrorMessage(asset, locale);
  } else {
    let currentError = errors;
    for (const path of errorPath) {
      currentError = currentError[path];
      if (!currentError) break;
    }
    const asset = currentError?.assets?.[index];
    errorMessage = getLocaleErrorMessage(asset, locale);
  }

  return errorMessage;
};

export const getFileNameByUrl = (url: string) => {
  if (!url) return '';
  return url.split('/')[url.split('/').length - 1];
};

export const getDisplayMessage = (errorCode: string, errorMessage: string) => {
  switch (errorCode) {
    case ERROR_MESSAGE_UPLOAD_ASSETS.NO_FILE_PROVIDED:
      return 'ไม่มีไฟล์ที่ถูกอัปโหลด';
    case ERROR_MESSAGE_UPLOAD_ASSETS.FILE_SIZE_EXCEEDED:
      return 'กรุณาอัปโหลดไฟล์ขนาดไม่เกิน 3 MB';
    case ERROR_MESSAGE_UPLOAD_ASSETS.FILE_TYPE_NOT_ACCEPTED:
      return 'ประเภทไฟล์ไม่รับรอง';
    case ERROR_MESSAGE_UPLOAD_ASSETS.FILE_NAME_TOO_LONG:
      return 'ชื่อไฟล์รวมนามสกุลไฟล์ต้องไม่เกิน 150 ตัวอักษร';
    default:
      return errorMessage;
  }
};
